import {startAppListening} from '@/redux/store/listenerMiddleware';

import addFeatureListeners from './featureListeners';
import reducer from './slice';

addFeatureListeners(startAppListening);

export default reducer;
